import {
    BastardsPlugin,
    ObserveVisibility,
    VueClickOutside
} from '@/plugins/plugins'
import {
    PageIndex,
    PageKupon,
    PageNoSampling,
    PageSampling,
    PageZgody
} from '@/pages'
import InputNumber from '@/components/form/InputNumber'
import InputNumberMultiple from '@/components/form/InputNumberMultiple'
import InputTextMultiple from '@/components/form/InputTextMultiple'
import ImageLazy from '@/components/image/ImageLazy'
import Loader from '@/components/loader/Loader'
import Tooltip from '@/components/tooltip/Tooltip'
import Typo from '@/components/typo/Typo'
import Validatable from '@/components/form/Validatable'

export default {
    /**
     * Global plugins booted by Vue.use
    */
    plugins: [
        BastardsPlugin,
        ObserveVisibility,
        VueClickOutside
    ],

    /**
     * Global components
     */
    components: {
        InputNumber,
        InputNumberMultiple,
        InputTextMultiple,
        ImageLazy,
        Loader,
        Tooltip,
        Typo,
        Validatable
    },

    /**
     * Router routes
     */
    router: {
        routes: [
            {
                name: 'index',
                path: '/',
                component: PageIndex,
                meta: {
                    title: 'Zgody - Makro Cash & Carry Polska',
                    templateType: 'homepage',
                    isGuest: true
                }
            },
            {
                name: 'zgody',
                path: '/zgody',
                component: PageZgody,
                meta: {
                    title: 'Sprawdź dane i wyraź zgodę - Zgody - Makro Cash & Carry Polska',
                    templateType: 'consents form',
                    isAuth: true
                }
            },
            {
                name: 'kupon',
                path: '/kupon',
                component: PageKupon,
                meta: {
                    title: 'Odbierz kupon rabatowy - Kupon rabatowy - Makro Cash & Carry Polska',
                    templateType: 'coupon',
                    isAuth: true
                }
            },
            {
                name: 'wycofaj',
                path: '/wycofaj/9498c70a-1c91-47f1-bd6a-ace865f730ee',
                component: PageIndex,
                meta: {
                    title: 'Zgody - Makro Cash & Carry Polska',
                    templateType: 'withdraw consent',
                    info: 'wycofaj'
                }
            },
            {
                name: 'sampling-index',
                path: '/sampling',
                component: null,
                meta: {
                    title: 'Zgody - Makro Cash & Carry Polska',
                    templateType: 'sampling',
                    isAuth: false
                }
            },
            {
                name: 'no-sampling',
                path: '/sampling/info',
                beforeEnter() {
                    window.location.href = "https://www.makro.pl/testuj-z-makro"
                },
                component: PageNoSampling,
                meta: {
                    title: 'Zgody - Makro Cash & Carry Polska',
                    templateType: 'sampling',
                    isAuth: false
                }
            },
            {
                name: 'sampling',
                path: '/sampling/:token',
                component: PageSampling,
                meta: {
                    title: 'Zgody - Makro Cash & Carry Polska',
                    templateType: 'sampling',
                    isAuth: false
                }
            }
        ]
    }
}
